import { Frame, Track, ViewPager } from 'react-view-pager';
import { KuposButton, KuposDataNotFound, KuposInput } from '../../../common';

import BIPAdministrator from './BIPAdministrator';
import Dots from './Dots';
import React from 'react';

function BIP(props) {
  return (
    <div className="my-bip-container">
      {props.bipItems.length > 0 ? (
        <div className="bip-top-strip">
          <div
            className="bip-icon-top back-arrow"
            onClick={() =>
              props.bipAdminScreen ? props.setBipAdminScreen(false) : props.setSelectedItem(null)
            }
          >
            <img src="/images/back_arrow_bip.png" />
          </div>

          <div>
            <div className="font13 center-text">
              {props.bipAdminScreen == false ? (
                <span>
                  {props.t('PROFILE.BIP_MAIN_TITLE.NORMAL')}
                  <span className="bold-text bip-top-strip-heading">
                    {' '}
                    {props.t('PROFILE.BIP_MAIN_TITLE.BOLD')}
                  </span>
                </span>
              ) : (
                <span>
                  {props.t('PROFILE.BIP_TITLE1.NORMAL')}
                  <span className="bold-text bip-top-strip-heading">
                    {props.t('PROFILE.BIP_TITLE1.BOLD')}!
                  </span>
                </span>
              )}
            </div>
            <div className="font11 center-text bip-top-strip-sub-heading">
              {props.bipAdminScreen == false ? (
                <span>{props.t('PROFILE.BIP_SUBTITLE')}</span>
              ) : (
                <span>{props.t('PROFILE.BIP_SUBTITLE1')}</span>
              )}
            </div>
          </div>
          <div className="bip-icon-top end-bip-icon">
            {props.bipAdminScreen == false ? (
              <div className="display-flex">
                <img onClick={() => props.setShowAddBIPCard(true)} src="/images/add_card.svg" />
                <div
                  className="font9 bip-admin-capsule"
                  onClick={() => props.setBipAdminScreen(true)}
                >
                  {props.t('PROFILE.MANAGE_CARDS')}
                </div>
              </div>
            ) : (
              <div className="bip-icon-top end-bip-icon end-bip-icon2">
                <img onClick={() => props.setShowAddBIPCard(true)} src="/images/add_card.svg" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="bip-top-strip">
          <div className="bip-icon-top back-arrow" onClick={() => props.setSelectedItem(null)}>
            <img src="/images/back_arrow_bip.png" />
          </div>
          <div></div>

          <div></div>
        </div>
      )}

      {!props.bipItems.length > 0 ? (
        <KuposDataNotFound
          icon="/images/bip_grey.svg"
          title={props.t('PROFILE.NO_BIP_CARD')}
          subTitle={props.t('PROFILE.MAKE_FIRST_RECHARGE')}
          infoText={props.t('PROFILE.ADD_FIRST_CARD')}
          onInfoClick={() => props.setShowAddBIPCard(true)}
        />
      ) : props.bipAdminScreen == false ? (
        <div className="bip-rows-container-main" sty>
          {console.log('Track of swiper', props.track)}

          <div style={{ marginTop: 10, marginBottom: 15, position: 'relative' }}>
            <ViewPager tag="main">
              <Frame className="frame">
                <Track
                  ref={c => (props.track = c)}
                  viewsToShow={1}
                  className="track"
                  onViewChange={e => props.setCardInFocus(e[0])}
                >
                  {props.bipItems.map((val, key) => {
                    return props.renderSingleBipcard(val, key);
                  })}
                </Track>
              </Frame>
              <nav
                className="pager-controls"
                style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  top: 60,
                  paddingLeft: 35,
                  paddingRight: 35,
                }}
              >
                <a
                  className="pager-control pager-control--prev "
                  onClick={() => props.track.prev()}
                >
                  <img className="control-icon" src="/images/icons/home/icon_arrow_left.png" />
                </a>
                <a className="pager-control pager-control--next" onClick={() => props.track.next()}>
                  <img className="control-icon" src="/images/icons/home/icon_arrow_right.png" />
                </a>
              </nav>

              <div
                style={{
                  position: 'absolute',
                  bottom: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // backgroundColor: '#f00',
                  width: '100%',
                }}
              >
                {props.bipItems.map((val, key) => (
                  <Dots key={key} cardInFocus={props.cardInFocus} />
                ))}
              </div>
            </ViewPager>
          </div>

          <div className="bip-sub-body-container">
            <div className="bip-sub-body-container-inner">
              <div className="recarge-input-label font10 bold-text">
                {props.t('PROFILE.RECHARGE_AMOUNT')}
              </div>

              <KuposInput
                placeholder="$XXXXX"
                className="kupos-border font10 bip-recharge-input"
                value={props.bipRechargeAmount}
                onBlur={val => props.onBipRechargeAmountBlur(val)}
                onChange={val => props.onBipRechargeAmountChange(val)}
                error={props.bipRechargeAmountError ? true : false}
                errorMessage={
                  props.bipRechargeAmountError ? props.bipRechargeAmountError.message : ''
                }
              />

              <div className="recarge-input-info-footer font8 light-grey-text">
                {props.t('PROFILE.RECHARGE_INPUT_FOOTER')}
              </div>
            </div>

            <div className="bip-recharge-button font12">
              <KuposButton onClick={() => props.goToBipRecharge()} className="bip-button-inner">
                {props.t('PROFILE.RECHARGE_BUTTON')}
              </KuposButton>
            </div>
          </div>
        </div>
      ) : (
        <BIPAdministrator
          t={props.t}
          bipItems={props.bipItems}
          showBipEditPopup={props.showBipEditPopup}
          showBipDeletePopup={props.showBipDeletePopup}
        />
      )}
    </div>
  );
}

export default BIP;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/BIP.js